import { BaseChip } from "@/shared/ui/base-chip";
import { Stack, useMediaQuery, useTheme } from "@mui/material";

export type SearchParamChipListProps<T extends string> = {
  params: {
    value: T;
    label: string;
  }[];
  onDelete: (value: T) => void;
};

export const SearchParamChipList = <T extends string>({
  params,
  onDelete,
}: SearchParamChipListProps<T>) => {
  const theme = useTheme();
  const isSmUp = useMediaQuery(theme.breakpoints.up("sm"));

  if (params.length === 0) {
    return null;
  }

  return (
    <Stack
      direction="row"
      flexWrap="wrap"
      gap={1}
      sx={{
        backgroundColor: theme.palette.primary[100],
        borderRadius: { xs: 1, sm: 2 },
        padding: { xs: 1, sm: 2 },
      }}
    >
      {params.map((param) => (
        <BaseChip
          key={param.value}
          label={param.label}
          // スマホはsmall
          size={isSmUp ? "medium" : "small"}
          onDelete={() => onDelete(param.value)}
        />
      ))}
    </Stack>
  );
};
